@let step2 = form();
<ng-container [formGroup]="step2">
  @if (!service.isEditing()) {
    <div class="form-row">
      <mat-form-field>
        <mat-label>Navn</mat-label>
        <input matInput placeholder="Navn på lokation" formControlName="name" />
        @if (step2.controls.name.invalid) {
          <mat-error>Indtast venligst lokationens navn</mat-error>
        }
      </mat-form-field>
    </div>
  }

  @if (step2.controls.addressWithoutDARValidation.value === false) {
    <adm-dep-address-typeahead
      [parentFormGroup]="step2"
      [initialAddress]="typeaheadInitialAddress()"
      [addressWithoutDARValidation]="step2.controls.addressWithoutDARValidation.value"
      [loading]="checkingNetArea()"
      (addressSelected)="selectAddress($event)" />
    <ng-container [ngTemplateOutlet]="netAreaWarning" />
  }
  <div class="form-row margin--bottom-l">
    <mat-slide-toggle formControlName="addressWithoutDARValidation" color="primary" (change)="onAddressValidationToggle($event)">
      <div>
        Angiv lokationens adresse uden DAR validering
        <mat-hint class="tiny-text">Brug hvis adressen f.eks. ikke findes endnu.</mat-hint>
      </div>
    </mat-slide-toggle>
  </div>
  @if (step2.controls.addressWithoutDARValidation.value) {
    <ng-container formGroupName="address">
      @let address = step2.controls.address.controls;
      <div class="form-row">
        <mat-form-field>
          <mat-label>Vejnavn</mat-label>
          <input matInput placeholder="Vejnavn" formControlName="street" />
          @if (address.street.hasError('required')) {
            <mat-error>Indtast venligst vejnavn</mat-error>
          } @else if (address.street.hasError('maxlength')) {
            <mat-error>Vejnavn må højst være {{ addressMaxLength.street }} tegn</mat-error>
          }
          @if (checkingNetArea()) {
            <ok-form-field-loading />
          }
        </mat-form-field>
      </div>
      <div class="form-row">
        <div class="grid-cols">
          <mat-form-field>
            <mat-label>Husnummer</mat-label>
            <input matInput placeholder="Husnummer" type="number" min="1" max="999" formControlName="houseNumber" />
            @if (address.houseNumber.hasError('required')) {
              <mat-error>Indtast venligst husnummer</mat-error>
            } @else if (address.houseNumber.hasError('houseNumber')) {
              <mat-error>Husnummer skal være mellem 1 og 999</mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>Bogstav</mat-label>
            <input matInput placeholder="Bogstav" maxlength="1" (keypress)="charactersOnly($event)" formControlName="houseLetter" />
            @if (address.houseLetter.invalid) {
              <mat-error>Bogstav skal være ét bogstav fra A-Z</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="form-row">
        <div class="grid-cols">
          <mat-form-field>
            <mat-label>Etage</mat-label>
            <input matInput placeholder="Etage" formControlName="floor" />
            <mat-hint>fx st, 1, 2 osv.</mat-hint>
            @if (address.floor.invalid) {
              <mat-error>Etage skal være st, kl, k2-k9 eller 1-99</mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>Dør</mat-label>
            <input matInput placeholder="Dør" formControlName="door" />
            <mat-hint>fx tv, th, mf</mat-hint>
            @if (address.door.invalid) {
              <mat-error>Dør skal være tv, th, mf, et tal eller op til 4 tegn</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="form-row">
        <div class="grid-cols">
          <mat-form-field>
            <mat-label>Postnr</mat-label>
            <input matInput placeholder="Postnr" maxlength="4" (keypress)="service.numericOnly($event)" formControlName="zipCode" />
            @if (address.zipCode.hasError('required')) {
              <mat-error>Indtast venligst postnummer</mat-error>
            } @else if (address.zipCode.invalid) {
              <mat-error>Postnummer skal være 4 cifre</mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>By</mat-label>
            <input matInput placeholder="By" formControlName="town" />
            @if (address.town.hasError('required')) {
              <mat-error>Indtast venligst by</mat-error>
            } @else if (address.town.hasError('maxlength')) {
              <mat-error>By må højst være {{ addressMaxLength.town }} tegn</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <ng-container [ngTemplateOutlet]="netAreaWarning" />
    </ng-container>
  }
  <ng-template #netAreaWarning>
    @if (noValidNetArea()) {
      <div class="form-row">
        <ok-feedback-info>
          <div>
            <b>Bemærk</b>
            <p>Der kan ikke findes et gyldigt netområde for lokationen, hvilket gør at dynamiske priser ikke kan blive tilknyttet.</p>
          </div>
        </ok-feedback-info>
      </div>
    }
  </ng-template>
  <div class="form-row">
    <div class="coordinates-container">
      <mat-form-field class="latitude-field">
        <mat-label>Latitude</mat-label>
        <input matInput placeholder="latitude" [inputMask]="service.geoLocationInputMask" formControlName="latitude" required />
        @if (step2.controls.latitude.hasError('required')) {
          <mat-error>Indtast venligst latitude</mat-error>
        }
      </mat-form-field>
      <mat-form-field class="longitude-field">
        <mat-label>Longitude</mat-label>
        <input matInput placeholder="Longitude" [inputMask]="service.geoLocationInputMask" formControlName="longitude" required />
        @if (step2.controls.longitude.hasError('required')) {
          <mat-error>Indtast venligst longitude</mat-error>
        }
      </mat-form-field>
      <button type="button" class="find-on-map-btn" matButton="outlined" (click)="openMap()">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#location-s"></use></svg>
        Find på kort
      </button>
    </div>
  </div>
  <div class="form-row">
    <mat-form-field>
      <mat-label>Konceptanlægsnr.</mat-label>
      <input matInput formControlName="conceptInstallationNumber" (keypress)="service.numericOnly($event)" />
      <mat-hint align="end"> {{ step2.controls.conceptInstallationNumber.value?.length || 0 }}/8 cifre </mat-hint>
      @if (
        step2.controls.conceptInstallationNumber.invalid &&
        (step2.controls.conceptInstallationNumber.dirty || step2.controls.conceptInstallationNumber.touched)
      ) {
        <mat-error>
          <div>Indtast venligst et gyldigt kWh konceptanlægsnr. (op til 8 cifre)</div>
        </mat-error>
      }
    </mat-form-field>
  </div>
  @if (service.powerPriceExclusionFeatureEnabled()) {
    <div class="form-row">
      <mat-slide-toggle formControlName="hasOkPowerMeter">
        <div>
          OK-måler
          <br />
          <mat-hint class="tiny-text">Lokationen har en elmåler der er ejet af OK</mat-hint>
        </div>
      </mat-slide-toggle>
    </div>
  }
  <div class="form-row">
    <mat-label>
      Målepunkts-ID'er
      @if (step2.controls.hasOkPowerMeter.value) {
        <span aria-hidden="true">*</span>
      }
    </mat-label>
    <div class="multi-select">
      <div class="multi-select__list multi-select__list--grid">
        @for (identifierControl of step2.controls.meteringPointIdentifiers.controls; track identifierControl; let index = $index) {
          <div
            class="multi-select__item multi-select__item--tall"
            [class.multi-select__item--invalid]="identifierControl.invalid"
            [class.highlight]="editingMeteringPointIdentifierIndex() === index">
            <span>5713131-{{ identifierControl.value }}</span>

            <button
              mat-icon-button
              type="button"
              title="Rediger"
              aria-label="Rediger målepunkts-ID"
              [disabled]="step2.controls.meteringPointIdentifiers.disabled"
              (click)="editMeteringPointIdentifier(index)">
              <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
            </button>

            <button
              mat-icon-button
              type="button"
              title="Fjern"
              aria-label="Fjern målepunkts-ID"
              [disabled]="step2.controls.meteringPointIdentifiers.disabled"
              (click)="removeMeteringPointIdentifier(index)">
              <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#trash-s"></use></svg>
            </button>
          </div>
        }

        <div class="multi-select__input">
          <mat-form-field>
            <span matTextPrefix>5713131-</span>
            <input
              matInput
              type="text"
              aria-label="Målepunkts-ID, 11 resterende cifre"
              inputmode="numeric"
              maxlength="11"
              [formControl]="meteringPointIdentifierDraft"
              [disabled]="step2.controls.meteringPointIdentifiers.disabled"
              (keypress)="service.numericOnly($event)" />

            @if (meteringPointIdentifierDraft.hasError('duplicate')) {
              <mat-error>Dette målepunkts-ID er allerede tilføjet</mat-error>
            }
            <mat-hint align="end"> {{ meteringPointIdentifierDraft.value.length || 0 }}/11 cifre </mat-hint>
          </mat-form-field>

          <button
            mat-flat-button
            class="add-button"
            type="button"
            title="Tilføj målepunkts-ID"
            aria-label="Tilføj målepunkts-ID"
            [disabled]="
              step2.controls.meteringPointIdentifiers.disabled ||
              !meteringPointIdentifierDraft.value ||
              meteringPointIdentifierDraft.invalid
            "
            (click)="saveMeteringPointIdentifier()">
            <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
          </button>

          @if (editingMeteringPointIdentifierIndex() !== null) {
            <button type="button" mat-icon-button class="cancel-button" (click)="cancelMeteringPointIdentifierEdit()">
              <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
            </button>
          }
        </div>

        @if (
          step2.controls.meteringPointIdentifiers.hasError('required') &&
          (step2.controls.meteringPointIdentifiers.dirty || step2.controls.meteringPointIdentifiers.touched)
        ) {
          <mat-error class="tiny-text">Tilføj mindst ét målepunkts-ID, når OK-måler er valgt </mat-error>
        }
      </div>
    </div>
  </div>
  <div class="form-row">
    <mat-form-field>
      <mat-label>Lokations begrænsning</mat-label>
      <mat-select formControlName="restricted" okCustomDropDownArrowDirective>
        <mat-option [value]="true">Begrænset</mat-option>
        <mat-option [value]="false">Offentlig</mat-option>
      </mat-select>
      <mat-icon matSuffix></mat-icon>
    </mat-form-field>
  </div>
  <div class="form-row">
    <mat-form-field>
      <mat-label>Hvilken app skal lokationen vises i</mat-label>

      <!-- Dropdown options are "Erhvervsappen", "Den offentlige app", and "Både erhvervsappen og den offentlige app". -->
      <mat-select formControlName="locationAppVisibility" okCustomDropDownArrowDirective>
        @for (visibility of locationAppVisibilityOptions; track visibility) {
          <mat-option [value]="visibility">{{ visibility | translateLocationAppVisibility }}</mat-option>
        }
      </mat-select>

      <mat-icon matSuffix></mat-icon>
    </mat-form-field>
  </div>
  <div class="form-row">
    <mat-form-field>
      <mat-label>App ikon</mat-label>
      <mat-select formControlName="locationAppVisibilityStatus" okCustomDropDownArrowDirective>
        @for (visibility of appVisibilityStatuses | enumToArray | translateLocationStatusEnum; track visibility.value) {
          <mat-option [value]="visibility.value"> {{ visibility.label }} </mat-option>
        }
      </mat-select>
      <mat-icon matSuffix></mat-icon>
      @if (
        step2.controls.locationAppVisibilityStatus.invalid &&
        (step2.controls.locationAppVisibilityStatus.dirty || step2.controls.locationAppVisibilityStatus.touched)
      ) {
        <mat-error>
          <div>Appikon skal vælges fra listen</div>
        </mat-error>
      }
      <mat-hint class="tiny-test"
        >Dette definerer udelukkende hvilken type ikon der vises i appen.
        <br />
        Hvis Skjult vises den ikke i appen.
      </mat-hint>
    </mat-form-field>
  </div>
  @if (step2.controls.locationAppVisibilityStatus.value === appVisibilityStatuses.Restrictions) {
    <div class="form-row">
      <mat-form-field class="mdc-textarea-fix">
        <mat-label>OBS tekst</mat-label>

        <textarea matInput formControlName="appLocationText" maxlength="100"></textarea>
        <mat-hint align="end"> {{ step2.controls.appLocationText.value?.length || 0 }}/100 karakterer </mat-hint>
        @if (step2.controls.appLocationText.hasError('maxlength')) {
          <mat-error>
            <div>OBS tekst skal være under 100 tegn</div>
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
  <div class="form-row">
    @if (
      step2.controls.locationAppVisibilityStatus.value === appVisibilityStatuses.Coming ||
      step2.controls.locationAppVisibilityStatus.value === appVisibilityStatuses.Hidden
    ) {
      <ok-feedback-info>Lokationen er ikke synlig i nogen af vores apps.</ok-feedback-info>
    } @else if (step2.controls.restricted.value === false) {
      @if (step2.controls.locationAppVisibility.value === locationAppVisibilities.Both) {
        <ok-feedback-info>Lokationen er synlig for alle i erhvervsappen og den offentlige app.</ok-feedback-info>
      }

      @if (step2.controls.locationAppVisibility.value === locationAppVisibilities.Commercial) {
        <ok-feedback-info>Lokationen er synlig for alle i erhvervsappen.</ok-feedback-info>
      }

      @if (step2.controls.locationAppVisibility.value === locationAppVisibilities.Public) {
        <ok-feedback-info>Lokationen er synlig for alle i den offentlige app.</ok-feedback-info>
      }
    } @else {
      @if (step2.controls.locationAppVisibility.value === locationAppVisibilities.Both) {
        <ok-feedback-info>
          Lokationen er begrænset og kun synlig for personer med adgang til lokationen i erhvervsappen og den offentlige app.
        </ok-feedback-info>
      }

      @if (step2.controls.locationAppVisibility.value === locationAppVisibilities.Commercial) {
        <ok-feedback-info>Lokationen er begrænset og kun synlig for personer med adgang til lokationen i erhvervsappen.</ok-feedback-info>
      }

      @if (step2.controls.locationAppVisibility.value === locationAppVisibilities.Public) {
        <ok-feedback-info
          >Lokationen er begrænset og kun synlig for personer med adgang til lokationen i den offentlige app.</ok-feedback-info
        >
      }
    }
  </div>
</ng-container>
